import { createContext, useContext } from 'react'

import type { CommentAudience } from './types'

const CommentAudienceContext = createContext<CommentAudience>('internal')

export const CommentAudienceProvider = CommentAudienceContext.Provider

export const useCommentAudience = () => useContext(CommentAudienceContext)
